<template>
  <div :class="label == 'Dashboard' ? 'mt-1 mb-4' : 'my-4'"  >
    <inertia-link :href="url">
      <div class="text-center">
        <img
          :src="hight ? img_active : img"
          style="margin: auto"
          class="d-block"
        />
        <span
          :style="{ color: hight ? '#8f67fe' : '#8a8d93 ' }"
          class="d-block f12"
          >{{ label }}</span
        >
      </div>
    </inertia-link>
  </div>
</template>

<script>
export default {
  props: ["url", "label", "img", "img_active", "active", "replace"],
  data: () => ({
    hight: false,
  }),
  mounted() {
    if (this.active == this.label) this.hight = true;
  },
};
</script>